module.exports = __webpack_public_path__ + "static/best-buy-8664dfb5cad5acde94091716caae0439.jpg";